// Sign in via email link stages
export const EMAIL_LINK_STAGES = {
    INPUT_EMAIL: 'Input Email',
    SENT_EMAIL: 'Sent Email',
    VERIFYING: 'Verifying',
    REINPUT_EMAIL: 'Reinput Email',
    NOTIFY_ERROR: 'Notify Error',
};
